import { Component } from '@angular/core'

@Component({
  selector: 'app-loader',
  imports: [],
  template: '',
  styleUrl: './loader.component.sass',
})
export class LoaderComponent {

}
